import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';
import { useSelector } from 'react-redux';

import css from './UserNav.module.css';

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ManageListingsPage')
 * @returns {JSX.Element} User navigation component
 */
const UserNav = props => {
  
  const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE;
  const { className, rootClassName, currentPage, showManageListingsLink } = props;
  const classes = classNames(rootClassName || css.root, className);
  
  const currentUser = useSelector(state => state.user.currentUser);

  //console.log("UserNav currentUser:", currentUser);

  const manageListingsTabMaybe = showManageListingsLink
    ? [
        {
          text: <FormattedMessage id="UserNav.yourListings" />,
          selected: currentPage === 'ManageListingsPage',
          linkProps: {
            name: 'ManageListingsPage',
          },
        },
      ]
    : [];

  const tabs = [
    
    ...manageListingsTabMaybe,
    {
      text: currentUser?.attributes?.profile?.publicData?.userType === 'tienda-oficial' ? <FormattedMessage id="UserNav.storeSettings" /> : <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    }
  ];

  if(currentUser?.attributes?.profile?.publicData?.userType === 'tienda-oficial'){
    tabs.splice(1, 0, {
      text: <FormattedMessage id="UserNav.yourStore" />,
      selected: currentPage === 'StoreFrontPage',
      disabled: false,
      linkProps: {
        name: 'StoreFrontPage',
        params: { 
          id: currentUser?.attributes?.profile?.publicData?.slug?.length 
            ? currentUser.attributes.profile.publicData.slug 
            : currentUser?.id?.uuid 
        },
      },
    });
  }

  if(COUNTRY_CODE === 'AR') {
    tabs.push(
      {
        text: <FormattedMessage id="UserNav.censoRodantero" />,
        selected: currentPage === 'CensoPage',
        disabled: false,
        linkProps: {
          name: 'CensoPage',
        },
      }
    )
  }

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

export default UserNav;
